import { render, staticRenderFns } from "./RsaPazienteSospensioneAdiPage.vue?vue&type=template&id=5c5ef896"
import script from "./RsaPazienteSospensioneAdiPage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteSospensioneAdiPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports